<template>
  <router-link
    v-if="myPermissions[permission]"
    v-bind="$attrs"
  >
    <slot/>
  </router-link>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AuthLink',
  inheritAttrs: false,
  props: {
    permission: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters('permission', [
      'myPermissions'
    ])
  }
}
</script>
